const routes = [
    {
        name: 'dadosEmpresaContabilidade',
        path: '/contabilidade/configuracoes/dados_empresa',
        component: () => import('../views/DadosEmpresa')
    },
    {
        name: 'listarLojasContabilidade',
        path: '/contabilidade/lojas',
        alias: '/contabilidade/lojas/index',
        component: () => import('../views/Listar')
    },
    {
        name: 'adicionarLojaContabilidade',
        path: '/contabilidade/lojas/adicionar',
        component: () => import('../views/Adicionar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'editarLojaContabilidade',
        path: '/contabilidade/lojas/editar/:id',
        component: () => import('../views/Editar'),
        meta: {
            fullScreen: true
        }
    },
    {
        name: 'visualizarLojaContabilidade',
        path: '/contabilidade/lojas/visualizar/:id',
        component: () => import('../views/Visualizar'),
    }
]

export default routes
